import api from 'core/api';

export const getProject = (uuid) => api.get(`/project/${uuid}`);
export const getProjects = () => api.get(`/projects`);
export const postProject = (data) => api.post('/project', data);
